// extracted by mini-css-extract-plugin
module.exports = {"base":"Tabs_base__s1J97","horizontal":"Tabs_horizontal__xigUE","vertical":"Tabs_vertical__nujSX"};